export default __webpack_public_path__ + "static/media/au_excd.392cbc25.jpg";